<template>
  <div class="contain">
    <div class="topTitle flex">
      <span class="preview">流量概览</span>
      <el-select
        v-model="region"
        placeholder="请选择商户"
        style="width: 200px"
        @change="MerchSelete"
      >
        <el-option
          v-for="(item, index) in seleteAppList"
          :key="index"
          :label="item.nickName"
          :value="index"
        ></el-option>
      </el-select>
    </div>

    <div class="seleData flex">
      <div class="seleflow flex">
        <div class="flex trend">流量趋势</div>
        <div class="flex">
          <div style="margin-right:20px">
            <el-button type="primary" @click="oldData">昨天</el-button>
          </div>

          <div class="block" style="margin-right:20px">
            <!-- <span class="demonstration">选择时间</span> -->
            <el-date-picker
              v-model="value1"
              @change="change"
              value-format="yyyy-MM-dd"
              type="date"
              placeholder="选择日期"
            >
            </el-date-picker>
          </div>
          <!-- <div class="seleteTime">
                    <el-date-picker
                      v-model="value1"
                      @change="change"
                      type="daterange"
                      value-format="yyyy-MM-dd"
                      range-separator="至"
                      start-placeholder="开始日期"
                      end-placeholder="结束日期">
                    </el-date-picker>
                </div> -->
          <el-button type="primary">导出</el-button>
        </div>
      </div>
      <div class="slide flex">
        <div class="newUser flex item-center">
          <img
            src="https://imgcdn.hemiao100.com/temp/42010216070190/2021-03-27/1616829047435-60c03891-56a8-42d2.png"
            alt=""
          />
          <div class="user flex">
            <span class="newUsers">新用户</span>
            <div class="capita flex">
              <span class="newNum">{{ visualData.visitUvNew }}</span>
              <div class="boaFence flex">
                <div class="time flex">
                  <span class="yesterday">较前一天</span>
                  <span class="num">{{
                    visualData.theDayBeforeVisitUvNew
                  }}</span>
                </div>
                <div class="increase">
                  <span>增减</span>
                  <span style="margin-left: 8px;">{{
                    visualData.visitUvNew - visualData.theDayBeforeVisitUvNew >
                    0
                      ? visualData.visitUvNew -
                        visualData.theDayBeforeVisitUvNew
                      : -(
                          visualData.visitUvNew -
                          visualData.theDayBeforeVisitUvNew
                        )
                  }}</span>
                  <span
                    class="el-icon-top success"
                    v-if="
                      visualData.visitUvNew -
                        visualData.theDayBeforeVisitUvNew >
                        0
                    "
                  ></span>
                  <span
                    class="el-icon-bottom danger"
                    v-if="
                      visualData.visitUvNew -
                        visualData.theDayBeforeVisitUvNew <
                        0
                    "
                  ></span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="newUser flex item-center">
          <img
            src="https://imgcdn.hemiao100.com/temp/42010216070190/2021-03-27/1616834220567-2ff01991-d3d6-424d.png"
            alt=""
          />
          <div class="user flex">
            <span class="newUsers">访问人数</span>
            <div class="capita flex">
              <span class="newNum">{{ visualData.visitUv }}</span>
              <div class="boaFence flex">
                <div class="time flex">
                  <span class="yesterday">较前一天</span>
                  <span class="num">{{ visualData.theDayBeforeVisitUv }}</span>
                </div>
                <div class="increase">
                  <span>增减</span>
                  <span style="margin-left: 8px;">{{
                    visualData.visitUv - visualData.theDayBeforeVisitUv > 0
                      ? visualData.visitUv - visualData.theDayBeforeVisitUv
                      : -(visualData.visitUv - visualData.theDayBeforeVisitUv)
                  }}</span>
                  <span
                    class="el-icon-top success"
                    v-if="
                      visualData.visitUv - visualData.theDayBeforeVisitUv > 0
                    "
                  ></span>
                  <span
                    class="el-icon-bottom danger"
                    v-if="
                      visualData.visitUv - visualData.theDayBeforeVisitUv < 0
                    "
                  ></span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="newUser flex item-center">
          <img
            src="https://imgcdn.hemiao100.com/temp/42010216070190/2021-03-27/1616834257511-403e3939-94a4-4072.png"
            alt=""
          />
          <div class="user flex">
            <span class="newUsers">人均停留时长</span>
            <div class="capita flex">
              <span class="newNum">{{ visualData.stayTimeUv }}</span>
              <div class="boaFence flex">
                <div class="time flex">
                  <span class="yesterday">较前一天</span>
                  <span class="num">{{
                    visualData.theDayBeforeStayTimeUv
                  }}</span>
                </div>
                <div class="increase">
                  <span>增减</span>
                  <span style="margin-left: 8px;">{{
                    visualData.stayTimeUv - visualData.theDayBeforeStayTimeUv >
                    0
                      ? visualData.stayTimeUv -
                        visualData.theDayBeforeStayTimeUv
                      : -(
                          visualData.stayTimeUv -
                          visualData.theDayBeforeStayTimeUv
                        )
                  }}</span>
                  <span
                    class="el-icon-top success"
                    v-if="
                      visualData.stayTimeUv -
                        visualData.theDayBeforeStayTimeUv >
                        0
                    "
                  ></span>
                  <span
                    class="el-icon-bottom danger"
                    v-if="
                      visualData.stayTimeUv -
                        visualData.theDayBeforeStayTimeUv <
                        0
                    "
                  ></span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="newUser flex item-center">
          <img
            src="https://imgcdn.hemiao100.com/temp/42010216070190/2021-03-27/1616835890562-b4d050bd-6a7e-4dcc.png"
            alt=""
          />
          <div class="user flex">
            <span class="newUsers">分享次数</span>
            <div class="capita flex">
              <span class="newNum">{{ visualData.sharePv }}</span>
              <div class="boaFence flex">
                <div class="time flex">
                  <span class="yesterday">较前一天</span>
                  <span class="num">{{ visualData.theDayBeforeSharePv }}</span>
                </div>
                <div class="increase">
                  <span>增减</span>
                  <span style="margin-left: 8px;">{{
                    visualData.sharePv - visualData.theDayBeforeSharePv > 0
                      ? visualData.sharePv - visualData.theDayBeforeSharePv
                      : -(visualData.sharePv - visualData.theDayBeforeSharePv)
                  }}</span>
                  <span
                    class="el-icon-top success"
                    v-if="
                      visualData.sharePv - visualData.theDayBeforeSharePv > 0
                    "
                  ></span>
                  <span
                    class="el-icon-bottom danger"
                    v-if="
                      visualData.sharePv - visualData.theDayBeforeSharePv < 0
                    "
                  ></span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="trend">
      <ve-line :data="chartData"></ve-line>
    </div>

    <div class="tabForm">
      <el-table
        stripe
        border
        ref="multipleTable"
        :data="tableData"
        style="width: 100%"
        id="table"
        size="small"
      >
        <el-table-column
          prop="eventDate"
          label="时间"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="visitUvNew"
          label="新用户数"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="visitUv"
          label="访问人数"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="visitPv"
          label="访问次数"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="stayTimeUv"
          label="人均停留时长(s)"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="sharePv"
          label="分享次数"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="shareUv"
          label="分享人数"
          align="center"
        ></el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import VeLine from "v-charts/lib/line.common";
export default {
  data() {
    return {
      region: "",
      value1: "",
      tableData: [],
      seleteAppList: [],
      initiali: {},
      yesterday: "", // 昨天
      visualData: {},
      chartData: {
        columns: [
          "dateValue",
          "新用户数",
          "访问人数",
          "访问次数",
          "人均停留时长",
          "分享次数",
          "分享人数"
        ],
        rows: []
      },
      storeCode: "",
      busType: ""
    };
  },
  components: {
    VeLine
  },
  created() {
    let curDate = new Date();
    var nowDate = curDate.getTime();
    var preDate = new Date(curDate.getTime() - 24 * 60 * 60 * 1000); //前一天
    this.yesterday = this.formatDateTime(preDate);
    if (this.$route.query.busType) {
      this.busType = this.$route.query.busType;
    }
    if (this.$route.query.storeCode) {
      this.storeCode = this.$route.query.storeCode;
    }
    this.getSeleteWechat();
  },
  methods: {
    change(e) {
      console.log(e);
      this.yesterday = e;
      this.get_init();
    },
    async getSeleteWechat() {
      const { result } = await this.$store.dispatch("queryWechatSelete", {});
      console.log(result);
      this.seleteAppList = result;
      this.region = 0;
      let self = this;
      if (this.storeCode && this.busType) {
        this.seleteAppList.forEach(function (item,index) {
          if (item.miniProgramType == self.busType && item.storeCode == self.storeCode) {
            self.region = index;
          }
        });
      }
      console.log(this.region);
      this.initiali = result[this.region];
      this.get_init();
    },
    MerchSelete(e) {
      console.log(e);
      let index = e;
      this.initiali = this.seleteAppList[index];
      this.get_init();
    },
    oldData() {
      this.value1 = "";
      let curDate = new Date();
      var nowDate = curDate.getTime();
      var preDate = new Date(curDate.getTime() - 24 * 60 * 60 * 1000); //前一天
      this.yesterday = this.formatDateTime(preDate);
      this.get_init();
    },
    formatDateTime(date) {
      var y = date.getFullYear();
      var m = date.getMonth() + 1;
      m = m < 10 ? "0" + m : m;
      var d = date.getDate();
      d = d < 10 ? "0" + d : d;
      var h = date.getHours();
      h = h < 10 ? "0" + h : h;
      var minute = date.getMinutes();
      minute = minute < 10 ? "0" + minute : minute;
      var second = date.getSeconds();
      second = second < 10 ? "0" + second : second;
      return y + "-" + m + "-" + d;
    },
    async get_init() {
      const { result } = await this.$store.dispatch("queryWechTrend", {
        busType: this.initiali.miniProgramType,
        queryStartDate: this.yesterday,
        storeCode: this.initiali.storeCode
      });
      if (result) {
        this.tableData = result.tableList;
        let broLine = result.tableList;
        let list = [];
        broLine.forEach(item => {
          list.push({
            dateValue: item.eventDate,
            新用户数: item.visitUvNew,
            访问人数: item.visitUv,
            访问次数: item.visitPv,
            人均停留时长: item.stayTimeUv,
            分享次数: item.sharePv,
            分享人数: item.shareUv
          });
        });
        this.chartData.rows = list;
        this.visualData = result.totalTrend;
        //   this.visualData.stayTimeUv = parseInt(this.visualData.stayTimeUv).toFixed(2)
        //  console.log(list)
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.contain {
  flex-direction: column;
  .topTitle {
    background: #fff;
    margin-bottom: 10px;
    padding: 20px;
    align-items: center;
    justify-content: space-between;
    // align-items: center;
    // border-bottom: 1px solid #e5e9f2;
    .preview {
      color: #222222;
      font-weight: 500;
      font-size: 26;
    }
  }
  .tips {
    padding: 20px 20px;
    background: #ffffee;

    span {
      color: #222222;
      font-size: 14px;
      font-weight: 400;
    }
  }
  .seleData {
    padding: 10px;
    flex-direction: column;
    // justify-content: flex-end;
    height: 232px;
    background: #ffffff;
    border-bottom: 10px;
    .seleflow {
      justify-content: space-between;
      .trend {
        height: 20px;
        border-left: 3px solid #e60669;
        padding: 0 5px;
        align-items: center;
      }
    }
    .slide {
      margin-top: 37px;
      margin-bottom: 10px;
      .newUser {
        width: 416px;
        height: 80px;
        padding: 20px 10px;
        box-shadow: 0px 0px 18px 0px rgba(221, 221, 221, 0.39);
        margin-right: 20px;
        img {
          width: 66px;
          height: 66px;
        }
        .user {
          flex-direction: column;
          margin-left: 20px;
          flex: 1;
          .newUsers {
            color: #222222;
            font-size: 14px;
            line-height: 2;
          }
          .capita {
            justify-content: space-between;
            align-items: center;
            .newNum {
              color: #222222;
              font-size: 24px;
              font-weight: 600;
            }
            .boaFence {
              margin-right: 20px;
              .time {
                margin-right: 10px;
                .yesterday {
                  color: #222222;
                  font-size: 14px;
                }
                .num {
                  color: #222222;
                  font-size: 14px;
                  margin-left: 6px;
                }
              }
              .increase {
                span {
                  color: #222222;
                  font-size: 14px;
                }
              }
            }
          }

          .newNum {
            color: #222222;
            font-weight: 600;
            font-size: 24px;
          }
        }
        .decrease {
          align-items: flex-end;
        }
      }
    }
  }
  .trend {
    margin-top: 10px;
    padding: 10px 20px;
    background: #ffffff;
  }
  .tabForm {
    padding: 0 20px;
    background: #ffffff;
  }

  // .translate {
  //   justify-content: space-between;
  //   align-items: center;
  //   padding: 10px;
  //   background: #f8f8f8;
  //   margin-top: 20px;
  //   .title {
  //     .pattern {
  //       display: block;
  //       width: 3px;
  //       height: 16px;
  //       background: #2a75ed;
  //       margin-right: 8px;
  //     }
  //   }
  // }

  // .timeProcess {
  //   justify-content: center;
  //   margin-top: 20px;
  //   .newUser {
  //     width: 200px;
  //     border: 1px solid #f2f2f2;
  //     padding: 15px;
  //     .describe {
  //       flex-direction: column;
  //       .new {
  //         margin-bottom: 6px;
  //         font-size: 14px;
  //       }
  //       .num {
  //         margin-bottom: 6px;
  //         font-size: 18px;
  //         font-weight: bold;
  //       }
  //       .days {
  //         margin-bottom: 6px;
  //         font-size: 14px;
  //         color: #aaaaaa;
  //       }
  //     }
  //   }
  // }
}
</style>
